import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, UserCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  // Handle scroll effect for shadow
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Live Classes',
    href: '#live',
    color: 'bg-[#F5A623] hover:bg-[#E09612]'
  }, {
    name: 'Zoom Classes',
    href: '#zoom',
    color: 'bg-[#F5A623] hover:bg-[#E09612]'
  }, {
    name: 'Online Classes',
    href: '#online',
    color: 'bg-[#F5A623] hover:bg-[#E09612]'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'shadow-md' : ''}`} data-id="element-66">
      {/* Top Bar - SEO Text & Contact Info (Desktop Only) */}
      <div className="bg-brand-purple-900 text-white py-2 hidden lg:block" data-id="element-67">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center text-sm font-medium" data-id="element-68">
          <div className="text-white" data-id="element-69">
            <span data-id="element-70">Arizona Real Estate License </span>
            <span className="text-[#F5A623] font-bold" data-id="element-71">Renewal</span>
            <span data-id="element-72"> Classes</span>
          </div>
          <div className="flex items-center space-x-8" data-id="element-73">
            <div className="flex items-center space-x-2 text-[#F5A623]" data-id="element-74">
              <Phone className="w-4 h-4" data-id="element-75" />
              <span data-id="element-76">Customer Service:</span>
              <span className="font-bold text-white" data-id="element-77">602-377-6207</span>
            </div>
            <a href="#contact" className="text-white hover:text-brand-orange-200 transition-colors" data-id="element-78">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Main Header Bar */}
      <div className="bg-white" data-id="element-79">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
          <div className="flex justify-between items-center h-20 lg:h-24" data-id="element-81">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center" data-id="element-82">
              <a href="/" className="flex items-center group" data-id="element-83">
                <img src="https://cdn.magicpatterns.com/uploads/6EDXC2FVxZjvEzYwwvW1XK/image.png" alt="Desert Sage Seminars" className="h-12 lg:h-14 w-auto" data-id="element-84" />
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-6" data-id="element-85">
              {/* Class Buttons */}
              <div className="flex items-center space-x-3" data-id="element-86">
                {navLinks.map(link => <a key={link.name} href={link.href} className={`px-5 py-2.5 text-sm font-bold text-brand-purple-900 rounded-md shadow-sm transition-all transform hover:-translate-y-0.5 ${link.color}`} data-id="element-87">
                    {link.name}
                  </a>)}
              </div>

              <div className="h-8 w-px bg-gray-200 mx-2" data-id="element-88"></div>

              {/* Login Button */}
              <Button className="bg-brand-purple-600 hover:bg-brand-purple-700 text-white font-bold px-6 py-2.5 shadow-md flex items-center gap-2" data-id="element-89">
                <UserCircle className="w-5 h-5" data-id="element-90" />
                Log In / Register
              </Button>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden flex items-center" data-id="element-91">
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-brand-purple-900 hover:bg-brand-purple-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-purple-500" data-id="element-92">
                <span className="sr-only" data-id="element-93">Open main menu</span>
                {isMenuOpen ? <X className="block h-7 w-7" aria-hidden="true" data-id="element-94" /> : <Menu className="block h-7 w-7" aria-hidden="true" data-id="element-95" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence data-id="element-96">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-t border-gray-100 overflow-hidden shadow-lg" data-id="element-97">
            <div className="px-4 pt-4 pb-6 space-y-3" data-id="element-98">
              {/* SEO Text - Mobile */}
              <div className="text-center text-sm font-medium text-brand-purple-900 pb-3 border-b border-gray-100" data-id="element-99">
                <span data-id="element-100">Arizona Real Estate License </span>
                <span className="text-[#F5A623] font-bold" data-id="element-101">Renewal</span>
                <span data-id="element-102"> Classes</span>
              </div>

              {navLinks.map(link => <a key={link.name} href={link.href} className={`block px-4 py-3 rounded-md text-base font-bold text-brand-purple-900 text-center shadow-sm ${link.color}`} onClick={() => setIsMenuOpen(false)} data-id="element-103">
                  {link.name}
                </a>)}

              <div className="pt-6 mt-4 border-t border-gray-100 space-y-4" data-id="element-104">
                <div className="flex items-center justify-center text-brand-purple-900 bg-gray-50 py-3 rounded-lg" data-id="element-105">
                  <Phone className="w-5 h-5 mr-2 text-[#F5A623]" data-id="element-106" />
                  <span className="font-medium mr-2" data-id="element-107">Customer Service:</span>
                  <span className="font-bold" data-id="element-108">602-377-6207</span>
                </div>

                <Button className="w-full bg-brand-purple-600 hover:bg-brand-purple-700 text-white font-bold py-3 flex justify-center items-center gap-2" data-id="element-109">
                  <UserCircle className="w-5 h-5" data-id="element-110" />
                  Log In / Register
                </Button>

                <a href="#contact" className="block text-center text-sm font-bold text-gray-500 hover:text-brand-purple-900 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-111">
                  Contact Us
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}